/*!
 * 2019-01-25 vector
 * If there are changes later, please list them here.
 */

//特殊字符  "*/\?<>:|
const _ASCII_UN_USE = [34, 42, 63, 60, 62, 58, 124];
const _ASCII_UN_USE_TWO = [34, 63, 60, 62, 58, 124];
const _ASCII_UN_USE_SUPPORT = [34, 60, 62, 58, 124]; // 工单提交输入限制去掉问号
//VMS系统限制字符 '"*/\?<>:|
const _ASCII_UN_USE_VMS = [39, 34, 42, 47, 92, 63, 60, 62, 58, 124];

//特殊字符  "*/\?<>:|[]
const _ASCII_UN_USE_THREE = [39, 34, 42, 47, 92, 63, 60, 62, 58, 124, 91, 93];

//场景自定义不支持所有特殊字符
const _ASCII_UN_USE_SCENE = [
  34, 40, 41, 42, 47, 92, 63, 60, 62, 58, 124, 33, 35, 36, 37, 38, 39, 40, 41, 43, 44, 45, 46, 58, 59, 61, 64, 91, 92, 93, 94,
  95, 96
];
/**
 * 判断输入是否有效
 * keyCode: 输入字符编码
 * inputType: 校验类型
 * specialCode: 特殊字符
 * source: 源字符
 */
const isValidInput = function (keyCode, type) {
  type = type.toLowerCase();
  //BackSpace按键通过
  if (keyCode === 8) {
    return true;
  }
  //10进制数字
  if ('ten' === type) {
    return 48 <= keyCode && keyCode <= 57;
  }
  //ip
  if ('ip' === type) {
    return (48 <= keyCode && keyCode <= 57) || keyCode === 46;
  }
  //Email 地址
  if ('email' === type) {
    let bln = false;
    if (keyCode === 64) {
      // @
      return true;
    }
    // space
    if (keyCode === 32) {
      return false;
    }
    for (let i = 0; i < _ASCII_UN_USE.length; i++) {
      if (keyCode === _ASCII_UN_USE[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  //文本
  if ('text' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE.length; i++) {
      if (keyCode === _ASCII_UN_USE[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }

  if ('text2' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE_TWO.length; i++) {
      if (keyCode === _ASCII_UN_USE_TWO[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  if ('text3' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE_THREE.length; i++) {
      if (keyCode === _ASCII_UN_USE_THREE[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  if ('text_vms' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE_VMS.length; i++) {
      if (keyCode === _ASCII_UN_USE_VMS[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  //电话 10进制数字,+,-
  if ('phone' === type) {
    return (48 <= keyCode && keyCode <= 57) || keyCode === 43 || keyCode === 45;
  }
  //过滤空格
  if ('nospace' === type) {
    return 32 !== keyCode;
  }
  //只允许字母和数字
  if ('alphanumeric' === type) {
    return (65 <= keyCode && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || (48 <= keyCode && keyCode <= 57);
  }
  if ('cloud-password' === type) {
    return 33 <= keyCode && keyCode <= 126;
  }
  //域名：字母、数字、-、.
  if ('domain' === type) {
    return (
      (65 <= keyCode && keyCode <= 90)
      || (keyCode >= 97 && keyCode <= 122)
      || (48 <= keyCode && keyCode <= 57)
      || 46 === keyCode
      || 45 === keyCode
    );
  }

  if ('text_without_emoji' === type) {
    // 不支持特殊字符，且不支持emoji
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE.length; i++) {
      if (keyCode === _ASCII_UN_USE[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  if ('text_scene' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE_SCENE.length; i++) {
      if (keyCode === _ASCII_UN_USE_SCENE[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }
  //文本
  if ('text-sup' === type) {
    let bln = false;
    for (let i = 0; i < _ASCII_UN_USE_SUPPORT.length; i++) {
      if (keyCode === _ASCII_UN_USE_SUPPORT[i]) {
        bln = true;
        break;
      }
    }
    return !bln;
  }

  return true;
};

/**
 * 处理键盘事件
 */
const handleKeypress = function (node, keyCode) {
  let handleType = 'text';
  const type = node.getAttribute('type');
  const inputType = node.getAttribute('data-input-type');

  if (inputType !== null) {
    handleType = inputType;
  } else if (type !== null) {
    handleType = type;
  }

  //密码框不做限制
  if (handleType.toLowerCase() === 'password') {
    return false;
  }

  return isValidInput(keyCode, handleType);
};

/**
 * 处理输入事件
 */
const handleInput = function (node) {
  let handleType = 'text';
  const type = node.getAttribute('type');
  const inputType = node.getAttribute('data-input-type');

  if (inputType !== null) {
    handleType = inputType;
  } else if (type !== null) {
    handleType = type;
  }

  //密码框不做限制
  if (handleType.toLowerCase() === 'password') {
    return false;
  }
  //EP配置校验规则的不做限制
  if (handleType === 'format') {
    return false;
  }

  const source = node.value;
  let dist = source;
  if (handleType === 'text_without_emoji') {
    // 不支持emoji
    const reg
      = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]|[\ufe0f][\u20e3]|[\u203c]|[\u2049]/g;
    dist = dist.replace(reg, '');
  }
  let distArr = dist.split('');
  dist = distArr.filter((item) => isValidInput(item.charCodeAt(0), handleType)).join('');

  if (dist !== source) {
    node.value = dist;
    const ev = document.createEvent('HTMLEvents');
    ev.initEvent('input', false, true);
    ev.customEvent = true;
    node.dispatchEvent(ev);
  }
};

const Plugin = {
  install: function (Vue) {
    Vue.directive('input-limit', {
      bind: function (el) {
        const nodes = el.querySelectorAll('input,textarea');
        for (let i = 0, len = nodes.length; i < len; i++) {
          const node = nodes[i];
          node.addEventListener('keypress', (e) => {
            if (!handleKeypress(node, e.keyCode || e.which)) {
              e.preventDefault();
              e.returnValue = false;
              return false;
            }
            return true;
          });
          node.addEventListener('input', (e) => {
            if (!e.customEvent) {
              handleInput(node);
            }
          });
          node.addEventListener('paste', () => {
            handleInput(node);
          });
        }
      }
    });

    /*input最大字符限制，el-input无法限制中文字符输入过程中的限制*/
    Vue.directive('max-length', {
      bind: function (el, binding) {
        let maxChars = binding.expression;
        const nodes = el.querySelectorAll('input,textarea');
        for (let i = 0, len = nodes.length; i < len; i++) {
          const node = nodes[i];
          let handlerInput = (e) => {
            if (e.target.value.length > maxChars) {
              e.target.value = e.target.value.substring(0, maxChars);
              e.target.dispatchEvent(new CustomEvent('input'));
            }
          };
          node.addEventListener('input', handlerInput);
        }
      }
    });

    /*input限制输入浮点数*/
    Vue.directive('float-only', {
      bind: function (el) {
        const nodes = el.querySelectorAll('input,textarea');
        const hasReg = /^\d*\.?\d*$/;
        const numberRgx = /[^0-9.]/g;
        for (let i = 0, len = nodes.length; i < len; i++) {
          const node = nodes[i];
          let handlerInput = (e) => {
            const val = e.target.value;
            if (hasReg.test(val) === false) {
              const start = e.target.selectionStart;
              const end = e.target.selectionEnd;
              const val1 = val.replace(numberRgx, ''); //替换掉[^0-9.]
              /*替换掉不是第一个出现的.*/
              e.target.value = val1.replace(/\./g, function (match, offset, all) {
                return match === '.' ? (all.indexOf('.') === offset ? '.' : '') : '';
              });
              e.target.setSelectionRange(start, end);
              e.target.dispatchEvent(new CustomEvent('input'));
            }
          };
          node.addEventListener('input', handlerInput);
        }
      }
    });
  }
};

export default Plugin;
